// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Delivery } from './delivery';
import { OrderLineDetail } from './order-line-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DeliveryStack extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  deliveryId!: number;
  notes?: string;
  orderLineDetailId?: number;
  stackPosition?: number;
  delivery!: Delivery;
  orderLineDetail!: OrderLineDetail;
}

